import { useEffect, useState } from 'react';
import App from '@/App';
import { consumeAuthCallback, postLoginPath } from '@/lib/auth';

/**
 * Lands the seitiate.app login redirect: reads the token from the URL fragment,
 * stores the session, and forwards into the HenniPenny workbench. Rendered by
 * main.tsx when the path is /auth/callback (it runs before the hash router boots).
 */
export function AuthCallback() {
  const [error, setError] = useState<string | null>(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const result = consumeAuthCallback();
    if (result.ok) {
      // Back to the page where the user asked to sign in (the workbench by default).
      window.history.replaceState(null, '', postLoginPath());
      setReady(true);
    } else {
      setError(result.error ?? 'Sign-in failed.');
    }
  }, []);

  if (ready) return <App />;

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        color: 'var(--theme-muted, #888)',
        fontSize: 14,
      }}
    >
      {error ? (
        <div style={{ textAlign: 'center', maxWidth: 360 }}>
          <p style={{ marginBottom: 12 }}>{error}</p>
          <a href="/" style={{ color: 'var(--theme-accent, #e8853d)' }}>
            Return to HenniPenny
          </a>
        </div>
      ) : (
        <p>Signing you in…</p>
      )}
    </div>
  );
}
